import { Directions, Gallery, ContentSection } from "@/components";
import { StyledContent } from "@/components/styles";
import { usePromise } from "@/hooks";
import { useRef, useState, useEffect, useMemo } from "react";
import api from "@/lib/api";
import axios from "axios";

const initialCount = 6;
function calcCurrentDirection(queryDirection, directions, defaultDirection) {
  if (!queryDirection) {
    return defaultDirection;
  } else {
    const currentDirection = directions.reduce((acc, cur) => {
      return cur.slug === queryDirection ? cur : cur.children?.find((i) => i.slug === queryDirection) ? cur : acc;
    }, null);
    return currentDirection || defaultDirection;
  }
}

const AboutGallery = ({ swiperData, ...props }) => {
  const [direction, setDirection] = useState({});
  const [count, setCount] = useState(initialCount);

  const { gallerySwiper } = swiperData;

  const updateSwiper = () => {
    if (gallerySwiper && gallerySwiper !== null && gallerySwiper.controller) {
      gallerySwiper.update();
    }
  };

  const cancelTokenSource = useRef(axios.CancelToken.source());
  const directionsPromise = usePromise(
    () =>
      api.directions({
        ...direction,
        cancelToken: cancelTokenSource.token,
      }),
    [direction],
    props,
    () => cancelTokenSource.current.cancel()
  );

  const { directions, current_direction: currentDirection, gallery } = directionsPromise.result;
  const loading = directionsPromise.status === "pending";

  const handleClick = (slug) => {
    setDirection({
      direction: slug,
    });
    setCount(initialCount);
  };

  const handleLoadMore = () => {
    setCount(count + initialCount);
  };

  useEffect(() => {
    if (directions?.length && !loading) {
      setTimeout(() => {
        updateSwiper();
      }, 50);
      if (!direction.direction) {
        setDirection({ direction: calcCurrentDirection(currentDirection.slug, directions, directions[0]).slug })
      }

    }
  }, [directions, loading, count, direction]);

  const galleryImages = useMemo(
    () =>
      gallery &&
      gallery.slice(0, count).map((i) => ({
        desktop: i?.main_page_desktop,
        tablet: i?.main_page_tablet,
        mobile: i?.main_page_mobile,
      })),
    [gallery, count]
  );

  return (
    <>
      {!!directions?.length && (
        <div className="no-content-swiping">
          <Directions directions={directions} active={currentDirection} onClick={handleClick} size="mid" />
        </div>
      )}

      <StyledContent.Loadable isLoading={loading}>
        {!!gallery?.length && (
          <ContentSection pb="x-small">
            <Gallery
              slider={false}
              images={{
                main: galleryImages,
                modal: galleryImages,
                modal_thumb: galleryImages,
              }}
            />
          </ContentSection>
        )}
        <StyledContent.Actions>
          {gallery && gallery.length > count && (
            <StyledContent.Link as="button" arrow onClick={handleLoadMore}>
              MORE PHOTOS
            </StyledContent.Link>
          )}
        </StyledContent.Actions>
      </StyledContent.Loadable>
    </>
  );
};

export default AboutGallery;
